export default class MetadadosAtendimentos {
  constructor(obj) {
    obj = obj || {};
    this.idUsuario = obj.idUsuario;
    this.loginUsuario = obj.loginUsuario;
    this.totalAbertos = obj.totalAbertos;
    this.totalAbertosNovos = obj.totalAbertosNovos;
    this.totalResolvidos = obj.totalResolvidos;
    this.totalResolvidosNoPrimeiroContato =
      obj.totalResolvidosNoPrimeiroContato;
    this.totalResolvidosDeTerceiros = obj.totalResolvidosDeTerceiros;
  }
}
